import { call, put, takeLatest, delay } from 'redux-saga/effects';
import {
    SUBMIT_AGENCY_SIGNUP_FORM,
    RESEND_AGENCY_EMAIL,
    CHECK_AGENCY_NAME,
    setAgencySignupStatus,
    setAgencySignupIsLoading,
    setAgencySignupEmailSent,
    setAgencyNameAvailable,
} from './actions';
import AgencySignupService from './service';
import { setGeneralError } from '../appLoadingState/actions';

const agencySignupService = new AgencySignupService();

export function* submitAgencySignupForm(action) {
    try {
        yield put(setAgencySignupStatus(null, null));
        yield put(setAgencySignupIsLoading(true));

        const { success, message: errorCode } = yield call(
            agencySignupService.submitAgencySignupForm,
            action.data
        );

        window.mixpanel.track('agency_sign_up_submit', {
            name: action.data.fullName,
            signup_email: action.data.email,
            company_name: action.data.companyName,
            has_live_integration: action.data.hasLiveIntegration,
            active_advertiser_clients: action.data.activeAdvertiserClients,
            server_error: errorCode,
            success: (!!success).toString(),
        });

        yield put(setAgencySignupIsLoading(false));
        yield put(setAgencySignupStatus(success ? 'success' : 'error', errorCode));
    } catch (res) {
        console.error(res);
        yield put(setAgencySignupIsLoading(false));
        yield put(setAgencySignupStatus('error', res.message));

        window.mixpanel.track('agency_sign_up_submit', {
            name: action.data.fullName,
            signup_email: action.data.email,
            company_name: action.data.companyName,
            has_live_integration: action.data.hasLiveIntegration,
            active_advertiser_clients: action.data.activeAdvertiserClients,
            server_error: res.message,
            success: 'false',
        });
    }
}

export function* resendAgencyEmail(action) {
    try {
        yield put(setAgencySignupIsLoading(true));
        yield put(setAgencySignupEmailSent(false));

        yield call(agencySignupService.resendEmail, action.data);

        yield put(setAgencySignupIsLoading(false));
        yield put(setAgencySignupEmailSent(true));

        yield delay(10000);
        yield put(setAgencySignupEmailSent(false));
    } catch (res) {
        if (res.message) {
            yield put(setGeneralError(res.message));
        } else {
            yield put(setGeneralError());
        }
        console.error(res);
        yield put(setAgencySignupIsLoading(false));
        yield put(setAgencySignupEmailSent(false));
    }
}

export function* checkAgencyName(action) {
    // debounce: wait before hitting the server
    yield delay(400);

    if (!action.agencyName || !action.agencyName.trim()) {
        yield put(setAgencyNameAvailable(null));
        return;
    }

    try {
        const { available } = yield call(
            agencySignupService.checkAgencyName,
            action.agencyName,
            action.email
        );
        yield put(setAgencyNameAvailable(available));
    } catch (res) {
        console.error(res);
        yield put(setAgencyNameAvailable(null));
    }
}

function* watchAgencySignup() {
    yield takeLatest(SUBMIT_AGENCY_SIGNUP_FORM, submitAgencySignupForm);
    yield takeLatest(RESEND_AGENCY_EMAIL, resendAgencyEmail);
    yield takeLatest(CHECK_AGENCY_NAME, checkAgencyName);
}

export const watchers = [watchAgencySignup];
